import { autoinject, PLATFORM, useView } from 'aurelia-framework';
import { ValidationController, ValidationControllerFactory, ValidationRules, Rule } from 'aurelia-validation';
import { MdcDialog } from '@aurelia-mdc-web/dialog';
import { IPromptDialogData } from '@aurelia-toolkit/alert';

export interface ITwoFieldPromptData {
  title?: string;
  label1: string;
  text1: string;
  required1?: boolean;
  label2: string;
  text2: string;
  required2?: boolean;
  okText?: string;
  cancelText?: string;
}

@autoinject()
@useView(PLATFORM.moduleName('./two-field-prompt-dialog.html'))
export class TwoFieldPromptDialog {
  constructor(private validationControllerFactory: ValidationControllerFactory) {
    this.validationController = this.validationControllerFactory.createForCurrentScope();
    this.rules = ValidationRules
      .ensure<ITwoFieldPromptData, string>(x => x.text1).required().when(x => !!x.required1)
      .ensure(x => x.text2).required().when(x => !!x.required2)
      .rules;
  }

  dialog: MdcDialog;
  data: ITwoFieldPromptData;
  validationController: ValidationController;
  rules: Rule<ITwoFieldPromptData, unknown>[][];

  activate(data: ITwoFieldPromptData) {
    this.data = data;
    this.validationController.addObject(this.data, this.rules);
  }

  async ok() {
    const result = await this.validationController.validate();
    if (result.valid) {
      this.dialog.close('ok');
    }
  }
}
